import { Component, OnInit, Input, SimpleChanges } from '@angular/core';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { UiFactory } from '../../core/ui/ui-factory';
import { ImageModel } from './image-model';
import { BehaviorService } from '../../core/behavior/behavior.service';

@Component({
  selector: 'pg-image-factory, grit-image-factoy',
  templateUrl: './pg-image-factory.component.html',
  styleUrls: ['./pg-image-factory.component.scss'],
})
export class PgImageFactoryComponent extends UiFactory {
  @Input() model: any;

  get imageModel(): ImageModel {
    return this.model;
  }

  safeImageSrc: SafeResourceUrl;
  setSafeImageSrc() {
    if (this.imageModel && this.imageModel.src) {
      this.safeImageSrc = this.domSanitizer.bypassSecurityTrustResourceUrl(
        this.imageModel.src
      );
    }
  }

  constructor(
    public domSanitizer: DomSanitizer,
    public behaviorService: BehaviorService
  ) {
    super(behaviorService);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.imageModel || changes.model) {
      this.setSafeImageSrc();
    }
  }
}
